import { PropsWithChildren } from 'react';

import { Wrapper } from './styled';

export interface IContainer {
  maxWidth?: 'lg' | 'xl';
  className?: string;
  noPadding?: boolean;
  id?: string;
  as?: React.ElementType;
}

const Container = ({
  children,
  maxWidth = 'lg',
  noPadding,
  ...rest
}: PropsWithChildren<IContainer>) => {
  return (
    <Wrapper noPadding={noPadding} maxWidth={maxWidth} {...rest}>
      {children}
    </Wrapper>
  );
};

export default Container;
